import NoMatch from 'components/_shared/NoMatch/NoMatch';

export default NoMatch;
